import { render } from "./FavoriteView.vue?vue&type=template&id=11f18bbe"
import script from "./FavoriteView.vue?vue&type=script&lang=js"
export * from "./FavoriteView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__